var map = {
	"./applet.svg": 6589,
	"./backToTop.svg": 444,
	"./business-license.svg": 5881,
	"./companyHome.svg": 7119,
	"./house.svg": 2743,
	"./localLife.svg": 808,
	"./logistics.svg": 3690,
	"./recruit.svg": 6461,
	"./register-login.svg": 8786,
	"./secondhand.svg": 7102,
	"./serviceAndPorduct.svg": 9880,
	"./top.svg": 8025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;